// extracted by mini-css-extract-plugin
export default {"noProducts":"index_noProducts__2Yc25","lead":"index_lead__3ySY_","link":"index_link__35UEn","main":"index_main__2z9IG"};